// extracted by mini-css-extract-plugin
export var button = "_n2-2";
export var card = "_n2-0";
export var closeButtonContainer = "_n2-3";
export var iconContainer = "_n2-1";